import React, { useState,useEffect} from "react";
import format from "date-fns/format";
import classnames from "classnames";
import { withRouter } from "react-router";

import constants from "../../../../constants";
import { DEFAULT_PIC, getDashboardPath } from "../../../../constants";
import {
  parseDateToLocal,
  parseTimeToLocal,
  convertTimeTo12HourFormat,
} from "../../../../utils/parseDateTime";
import moment from "moment";
import { getUserData } from "../../../../utils/localStorage";

import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import Button from "../../../../components/formElements/button/Button";
import Modals from "../../../../components/uiElements/popupModal/modal";
import AddParticipants from "../InCall/AddParticipants";
import { useDispatch } from "react-redux";
import { reviewChartNotification } from "../../../../store/actions/appointmentActions";

const AppointmentDetailInfo = ({
  appointmentData,
  history,
  type = "",
  onAccept,
  onReschedule,
  onDeny,
  onCancel,
  onStart,
  onGuestSuccess,
  onCancelInvite,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [reviewPatient, setReviewPatient] = useState(false);
  
  const isGuest = appointmentData?.guest_doctor_id === getUserData()?.id;
  const isDoctor = appointmentData?.doctor_detail?.id === getUserData()?.id;
  let dispatch = useDispatch();
  
  let guest;
  let isThirdGuest = false;
  let join=appointmentData?.is_joined
 
  if (isGuest) {
    guest = appointmentData?.doctor_detail;
  } else if (isDoctor) {
    guest = appointmentData?.guest_doctor;
  } else {
    guest = appointmentData?.doctor_detail;
    isThirdGuest = true;
  }

  const scheduledStatus = [
    constants.APPOINTMENT_STATUS.requested,
    constants.APPOINTMENT_STATUS.accepted,
  ];

  const deniedStatus = [
    constants.APPOINTMENT_STATUS.denied,
    constants.APPOINTMENT_STATUS.cancelled,
  ];
  let current_time=moment(new Date()).format("HH:mm")
  let today_date=moment(new Date()).format("YYYY-MM-DD ") 
  let current_date=moment(new Date()).format("YYYY-MM-DD") 
  let start = new Date(today_date+current_time);
  let end = new Date(today_date + appointmentData?.startTime);
  let difference = end-start;
  let hours = Math.floor(difference / 1000 / 60 / 60);
  difference -= hours * 1000 * 60 * 60;

  let minutes = Math.floor(difference / 1000 / 60);
  difference -= minutes * 1000 * 60;
  let difer=hours +" " + minutes
  let diference=minutes
  let startcall = true
  let reschedule= false
  let cancel=true
  
  if(diference<="5" && current_date==appointmentData?.appointmentDate
   && appointmentData?.status === "ACCEPTED"){
        startcall = true
        reschedule= false
    }
    else if(difer[0]=="-" && current_date==appointmentData?.appointmentDate && 
    appointmentData?.status === "ACCEPTED")
    {
      startcall = true
      reschedule= false
    }
    else if(appointmentData?.status === "ACCEPTED"){
      startcall = false
      reschedule= true
    }
    else if (appointmentData?.status==="REQUESTED"){
      reschedule=true
    }
  
    if (appointmentData?.is_joined==true && appointmentData?.status === "ACCEPTED"){
      
      startcall = true
      reschedule= false
      cancel= false
    }
    else if (appointmentData?.status === "ACCEPTED"){
      cancel=true
    }
  return (
    <>
      <Modals
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(!isOpen)}
        title="Add another physician"
        styles={{
          content: {
            minWidth: "552px",
            maxWidth: "552px",
            minHeight: "550px",
            maxHeight: "550px",
            paddingBottom: 0,
            overflowY: "scroll",
          },
        }}
      >
        <React.Fragment>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <AddParticipants
            futureAppointment={true}
            appointmentFlow={
              type !== "scheduled" ? "appointment_detail" : "scheduled"
            }
            onClose={() => setIsOpen(false)}
            onGuestSuccess={() => onGuestSuccess()}
          />
        </React.Fragment>
      </Modals>
      <div
        className={classnames(
          "slotTitle pb-4 ",
          appointmentData?.status === constants.APPOINTMENT_STATUS.accepted &&
            !isGuest &&
            !scheduledStatus.includes(appointmentData?.guest_doctor_status) &&
            "mt-n4"
        )}
      >
        {appointmentData?.status === constants.APPOINTMENT_STATUS.accepted &&
          !isGuest &&
          !scheduledStatus.includes(appointmentData?.guest_doctor_status) &&
          isDoctor && (
            <div
              className={classnames(
                "d-inline",
                type !== "scheduled" ? "col-md-4" : "col-md-5"
              )}
            >
              <Button
                className={classnames(
                  "h-25 float-right",
                  "col-md-auto w-auto px-4"
                )}
                label={"Add another Physician"}
                onClick={() => setIsOpen(true)}
              />
            </div>
          )}

        <div className="col-md-4 p-0">
          {type !== "scheduled" && (
            <span
              className="ml-n3 pr-1"
              style={{
                cursor: "pointer",
              }}
            >
              <AppointmentIcon
                type="leftArrow"
                onClick={() => history.goBack()}
              />
            </span>
          )}
          Appointment Details{" "}
          {type !== "scheduled" && (
            <span
              className="ml-2 badge badge-primary"
              style={{
                color: "#FFFF",
              }}
            >
              {(deniedStatus.includes(appointmentData?.status) &&
                appointmentData?.status) ||
                (isDoctor && appointmentData?.status) ||
                (isGuest &&
                  appointmentData?.status !== "RESCHEDULE_REQUEST" &&
                  appointmentData?.status !== "REQUESTED" &&
                  appointmentData?.guest_doctor_status) ||
                constants.APPOINTMENT_STATUS.cancelled}
            </span>
          )}
        </div>
      </div>{" "}
      <p>
        <AppointmentIcon type="time" />
        <span>
          {format(
            parseDateToLocal(appointmentData?.appointmentDate) || new Date(),
            "EEEE, dd MMMM"
          )}{" "}
          • {convertTimeTo12HourFormat(appointmentData?.startTime)} -{" "}
          {convertTimeTo12HourFormat(appointmentData?.endTime)}
        </span>
      </p>
      <p>
        <AppointmentIcon type="tag" />
        <span>{appointmentData?.topic}</span>
      </p>
      <p>
        <AppointmentIcon type="users" />
        <span>Participants:</span>
      </p>
      <div className="row">
        <div className={type !== "scheduled" ? "col-md-4" : "col-md-6 pb-3"}>
          <div
            className="profile-card"
            style={{
              width:
                (!appointmentData?.guest_doctor_status ||
                  deniedStatus.includes(
                    appointmentData?.guest_doctor_status
                  )) &&
                !appointmentData?.is_dependent_invited
                  ? 338
                  : "auto",
            }}
          >
            <span className="content-center">
              <img
                src={appointmentData?.patient_detail?.image || DEFAULT_PIC}
                className="profile-image-primary content-center ml-5"
                alt={appointmentData?.id}
              />
              <span
                className="my-5 col-md-8"
                style={{
                  verticalAlign: "middle",
                }}
              >
                <p
                  className="m-0 slotTitle"
                  style={{
                    fontSize: 20,
                  }}
                >
                  {appointmentData?.patientName}
                </p>
                <p className="m-0 appointment-font-primary">Patient</p>
                <p
                  className="m-0"
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push({
                      pathname: getDashboardPath(`/patients/detail/${appointmentData?.patient_detail.id}`),
                      state:{pop:true}
                   })
                   if(appointmentData?.status == constants.APPOINTMENT_STATUS.accepted){
                    dispatch(reviewChartNotification(appointmentData?.id));}
                  }}
                >
                  View Profile
                </p>
              </span>
            </span>
          </div>
        </div>
        {((appointmentData?.guest_doctor &&
          (scheduledStatus.includes(appointmentData?.guest_doctor_status) ||
            isGuest) &&
          Object.keys(appointmentData?.guest_doctor)?.length > 0) ||
          isThirdGuest) && (
          <div className={type !== "scheduled" ? "col-md-4" : "col-md-6"}>
            <div className="profile-card">
              <span className="content-center">
                <img
                  src={guest?.image || DEFAULT_PIC}
                  className="profile-image-primary content-center ml-5"
                  alt={guest?.id}
                />
                <span
                  className="my-5 col-md-8"
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  <p
                    className="m-0 slotTitle"
                    style={{
                      fontSize: 20,
                    }}
                  >
                    {guest?.first_name} {guest?.last_name}
                  </p>
                  <p
                    className={classnames(
                      "m-0 appointment-font-primary",
                      !readMore && "text-truncate"
                    )}
                    onClick={() => setReadMore(true)}
                  >
                    {guest?.speciality?.join(", ")}
                  </p>
                  {!isGuest &&
                    !isThirdGuest &&
                    !deniedStatus.includes(appointmentData?.status) && (
                      <p className="m-0 appointment-font-primary">
                        <AppointmentIcon type="cancel" className="mr-auto" />{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            verticalAlign: "middle",
                          }}
                          onClick={() =>
                            onCancelInvite(
                              appointmentData?.id,
                              "CANCEL_INVITE",
                              onGuestSuccess
                            )
                          }
                        >
                          Cancel Invite
                        </span>
                      </p>
                    )}
                </span>
              </span>
            </div>
          </div>
        )}

        {appointmentData?.is_dependent_invited &&
          appointmentData?.parent_details && (
            <div className={type !== "scheduled" ? "col-md-4" : "col-md-6"}>
              <div className="profile-card">
                <span className="content-center">
                  <img
                    src={
                      appointmentData?.parent_details?.user__image ||
                      DEFAULT_PIC
                    }
                    className="profile-image-primary content-center ml-5"
                    alt={guest?.id}
                  />
                  <span
                    className="my-5 col-md-8"
                    style={{
                      verticalAlign: "middle",
                    }}
                  >
                    <p
                      className="m-0 slotTitle"
                      style={{
                        fontSize: 20,
                      }}
                    >
                      {appointmentData?.parent_details?.user__first_name}{" "}
                      {appointmentData?.parent_details?.user__last_name}
                    </p>
                    <p className="m-0 appointment-font-primary">Parent</p>
                  </span>
                </span>
              </div>
            </div>
          )}
      </div>
      <div
        className={classnames(
          "content-center mt-3",
          type === "scheduled" ? "mt-4" : "col-md-7 pl-0"
        )}
      >
        {appointmentData?.status === "ACCEPTED" && startcall &&(
          <Button
            label={
              join===false
                ? "Start call"
                : "Rejoin"
            }
            className="w-50 mr-2"
            onClick={() => onStart(appointmentData?.id)}
          />
        )}
        {(isGuest
          ? appointmentData?.guest_doctor_status !==
              constants.APPOINTMENT_STATUS.cancelled &&
            appointmentData?.guest_doctor_status !==
              constants.APPOINTMENT_STATUS.denied &&
            appointmentData?.status !== "RESCHEDULE_REQUEST" &&
            appointmentData?.status !== "REQUESTED" &&
            !deniedStatus.includes(appointmentData?.status)
          : appointmentData?.status !== constants.APPOINTMENT_STATUS.denied &&
            appointmentData?.status !==
              constants.APPOINTMENT_STATUS.cancelled &&
            appointmentData?.status !==
              constants.APPOINTMENT_STATUS.autoDenied) &&
          !isThirdGuest && (
            <>
              {((appointmentData?.status !== "COMPLETED" &&
              appointmentData?.status !==
                  constants.APPOINTMENT_STATUS.accepted  &&
              appointmentData?.status !== 
                  constants.APPOINTMENT_STATUS.rescheduleRequest && appointmentData?.status !== 
                  "AUTO_CANCELLED" && appointmentData?.status !== 
                  "NO_SHOW") ||
                (isGuest &&
                  appointmentData?.guest_doctor_status === "REQUESTED")) && (
                <Button
                  label="Accept"
                  className="btn-block w-50 mr-2"
                  onClick={onAccept}
                />
              )}
              {appointmentData?.status !== "COMPLETED" &&
                appointmentData?.status !==
                  constants.APPOINTMENT_STATUS.rescheduleRequest &&
                 reschedule &&
                !isGuest && 
                  <Button
                    label="Reschedule"
                    className="btn-block w-50 mr-2"
                    onClick={onReschedule}
                  />
                }
              {(appointmentData?.status !== "COMPLETED" &&
                appointmentData?.status ==="REQUESTED") ||
              (isGuest &&
                appointmentData?.guest_doctor_status === "REQUESTED") ? (
                <Button
                  type="outline"
                  label="Deny"
                  className="btn-block w-50 mr-2"
                  onClick={onDeny}
                />
              ) : appointmentData?.status !== "COMPLETED" &&  appointmentData?.status !== 
              "AUTO_CANCELLED"&&   appointmentData?.status !== "REQUESTED" && 
              appointmentData?.status !== "NO_SHOW" && cancel ? (
                <Button
                  type="outline"
                  label="Cancel"
                  className="btn-block w-50 mr-2"
                  onClick={onCancel}
                />
              ) : (
                ""
              )}
            </>
          )}
      </div>
    </>
  );
};

export default withRouter(AppointmentDetailInfo);
